import { sendStateAndCodeToBackend } from '@/apis/courseApis'
import { ToastNotify } from '@/common/toastManager'
import { Storage } from '@/helpers/Storage'
import { errorHandlerDisplay, withAsync } from '@/helpers/withAsync'
import useQueryParams from '@/hooks/useQueryParams'
import { CERTIFICATION_LINKEDIN_KEY } from '@/pages/course/alumni/components/completedCourse/CertificateComplete'
import { useShareCourseCertificateMutation } from '@/store/courseSlice'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import LoadingText from '../components/LoadingText'
import { useTranslation } from 'react-i18next'
import Typography from '@/common/Typography'
// import { getAlumniProfile } from '@/apis/profileApis'

const LinkedInCallback = () => {
  const { t } = useTranslation()
  const { code, state } = useQueryParams()
  const [shareCertificateAction, { isLoading: isSharing }] =
    useShareCourseCertificateMutation()
  const navigate = useNavigate()
  useEffect(() => {
    if (!code || !state) return
    const storedData = Storage.getItem(CERTIFICATION_LINKEDIN_KEY)
    if (!storedData) return
    sendStateAndCodeToBackend({ code, state })
      .then(async (res) => {
        const { error, response } = await withAsync(() =>
          shareCertificateAction({
            id: storedData.courseId,
            accessToken: storedData.accessToken,
          }).unwrap()
        )
        if (error) {
          return errorHandlerDisplay(error)
        }
        if (response) {
          Storage.removeItem(CERTIFICATION_LINKEDIN_KEY)

          // const {error, response } = await withAsync(() => getAlumniProfile(storedData))
          navigate(
            `/alumni/app/course/completed-courses?course=${storedData.course}&courseId=${storedData.courseId}`,
            {
              replace: true,
            }
          )
          ToastNotify('success', { message: (response as any).message })
        }
      })
      .catch((err) => {
        console.error(err, 'ERROR')
      })
  }, [code, state, navigate, shareCertificateAction])
  return (
    <article className='px-4 w-full flex flex-col gap-6 sm:gap-10 justify-start items-center sm:px-[19%] mb-12'>
      <header className='flex flex-col gap-1 w-full self-start my-10'>
        <Typography
          as='h2'
          className='h3 text-jaa-shades-black  sm:h2 whitespace-nowrap'
        >
          Sharing Certification
        </Typography>
        <Typography as='p' className='text-jaa-shades-gray-2.5 font-normal sm'>
          Hang in tight... Sharing your certification with the platform
        </Typography>
      </header>
      <LoadingText loading={isSharing} text={t('app.auth.finishing_setup')} />
    </article>
  )
}

export default LinkedInCallback
